// @ts-nocheck
import React from "react";
import { ReactComponent as HomeSmile } from "../../assets/icons/home-smile.svg";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setFlyLocation } from "../store/mapStateSlice";

const DataSourceRecord = ({ dataSource, onDelete, onClick, isActive = true }) => {
  const dispatch = useDispatch();
  const { groupid, assetid } = useParams();
  const navigate = useNavigate();
  const handleAssetClick = () => {
    onClick()
  };

  const handleDelete = (e) => {
    onDelete()
    e.stopPropagation();
  }

  return (
    <div
      onClick={handleAssetClick}
      className={`group cursor-pointer relative h-[140px] ${isActive ? 'bg-white' : 'bg-gray-50 opacity-80'} hover:bg-gray-100 pl-[24px] pr-[22px] py-[20px] border-b border-gray-200 ${isActive ? 'border-l-4 border-l-eai-accent-grn' : ''}`}
    >
      <div className="grid grid-cols-[auto,1fr,auto] items-start gap-2 max-w-full">
        {/* Icon */}
        <div className="justify-center items-center inline-flex">
          <div className="p-2 bg-zinc-700 rounded-md justify-start items-center inline-flex">
            <div className="w-6 h-6 flex justify-center text-white">
              <HomeSmile />
            </div>
          </div>
        </div>

        {/* Text content */}
        <div className="pt-1 min-w-0">
          <div className="text-gray-900 text-sm font-semibold font-Inter truncate">
            {dataSource.config?.assetName || "Unknown Asset"}
          </div>
          <div className="truncate">
            <span className="text-gray-500 text-xs font-normal font-['Inter']">{dataSource.model?.label || 
                    (dataSource.model?.properties && dataSource.model.properties.label) || 
                    dataSource.label || "Unknown Model"}</span>
          </div>
        </div>
        
        {/* Delete button */}
        <div className="pt-1 flex-shrink-0">
          <button 
            onClick={handleDelete} 
            className="px-2 py-1 bg-red-100 text-red-600 hover:bg-red-200 rounded-md flex items-center text-xs font-medium whitespace-nowrap"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            Delete
          </button>
        </div>
      </div>
      
      <div className="flex gap-2 py-[5px]"></div>
      
      <div className="flex gap-[8%] border-t border-gray-200 group-hover:border-gray-300 mt-2">
        <div>
          <div className="text-gray-500 text-[10px] font-semibold pt-2 pb-1 px-1">
            Type
          </div>
          <div className="text-gray-900 text-xs font-medium p-1 truncate max-w-[110px]">
            {dataSource.config?.modelName || dataSource.attributes?.name || "N/A"}
          </div>
        </div>
        <div>
          <div className="text-gray-500 text-[10px] font-semibold pt-2 pb-1 px-1">
            Date
          </div>
          <div className="text-gray-900 text-xs font-medium p-1 truncate max-w-[140px]">
            {dataSource.resource?.dateIssued ? 
              (() => {
                const dateParts = dataSource.resource.dateIssued.split('-');
                if (dateParts.length >= 4) {
                  const year = dateParts[0];
                  const month = parseInt(dateParts[1]);
                  const day = parseInt(dateParts[2]);
                  const hour = parseInt(dateParts[3]);
                  
                  // Format as YYYY-MM-DD HH:MM
                  const monthStr = month.toString().padStart(2, '0');
                  const dayStr = day.toString().padStart(2, '0');
                  const hourStr = hour.toString().padStart(2, '0');
                  return `${year}-${monthStr}-${dayStr} ${hourStr}:00`;
                }
                return dataSource.resource.dateIssued;
              })() : 
              "Latest"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataSourceRecord;
